<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M16.6654 11.4596C16.6654 11.1145 16.3855 10.8346 16.0404 10.8346H13.5404C13.1952 10.8346 12.9154 11.1145 12.9154 11.4596V17.0846H11.6654V3.54297C11.6654 2.93604 11.664 2.54373 11.6252 2.25466C11.5887 1.98357 11.5299 1.8986 11.4823 1.85103C11.4347 1.80345 11.3498 1.74461 11.0787 1.70816C10.7896 1.66929 10.3973 1.66797 9.79036 1.66797C9.18345 1.66797 8.79111 1.66929 8.50203 1.70816C8.23096 1.74461 8.146 1.80345 8.09842 1.85103C8.05085 1.8986 7.992 1.98357 7.95556 2.25466C7.91669 2.54373 7.91536 2.93604 7.91536 3.54297V17.0846H6.66536V7.29297C6.66536 6.94779 6.38554 6.66797 6.04036 6.66797H3.54036C3.19519 6.66797 2.91536 6.94779 2.91536 7.29297V17.0846H1.66536H1.45703C1.11186 17.0846 0.832031 17.3645 0.832031 17.7096C0.832031 18.0548 1.11186 18.3346 1.45703 18.3346H18.1237C18.4689 18.3346 18.7487 18.0548 18.7487 17.7096C18.7487 17.3645 18.4689 17.0846 18.1237 17.0846H17.9154H16.6654V11.4596Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'EtaxStatsIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>